export default class EventTarget {
	static get TARGET_TYPE() {
		const TARGET_TYPE = {
			LISTROW: 0,
			SCHEDULE_MOVE: 1,
			SCHEDULE_STRECH_BEGIN: 2,
			SCHEDULE_STRECH_END: 3,
			CHART_ROW_MOUSE_MOVE: 4,
			
		};
		return TARGET_TYPE;
	}
	get isScheduleMove() { return EventTarget.TARGET_TYPE.SCHEDULE_MOVE === this.target_type;}
	get isScheduleStrechBegin() { return EventTarget.TARGET_TYPE.SCHEDULE_STRECH_BEGIN === this.target_type;}
	get isScheduleStrechEnd() {return EventTarget.TARGET_TYPE.SCHEDULE_STRECH_END === this.target_type;}
	constructor(params) {
		this.target = params.target;
		this.target_type = params.target_type;
	}
}
